import React, { Fragment, useEffect, useState } from 'react'
import IntlMessage from 'components/util-components/IntlMessage'
import { Link, useLocation } from 'react-router-dom'
import { classNames } from 'utils'
import { ChevronDownIcon } from '@heroicons/react/outline'
import { Transition } from '@headlessui/react'

const MenuLink = ({ menu, active, onClick }) => {
    return (
        <Link
            className={classNames(
                active 
                    ? "bg-gradient-to-r from-monko/90 to-monko-600/90 text-white shadow-lg shadow-monko/10" 
                    : "text-slate-600 hover:text-monko hover:bg-monko/5",
                "h-[48px] px-4 flex items-center rounded-2xl mb-1 relative group w-full flex-row justify-start text-xs font-medium space-x-3 transition-all duration-200"
            )}
            to={menu.path}
            onClick={onClick}
        >
            <menu.icon
                className={classNames(
                    active ? 'fill-white' : 'fill-slate-500 group-hover:fill-monko',
                    'h-6 w-6 transition-colors duration-200'
                )}
            />
            <span
                className={classNames(
                    active ? 'text-white font-bold' : 'text-slate-600 group-hover:text-monko font-semibold',
                    'text-sm transition-colors duration-200'
                )}
            >
                <IntlMessage id={menu.title} />
            </span>
        </Link>
    )
}

const MenuItem = ({ menu, onClick }) => {
    const location = useLocation()
    const [subnav, setSubnav] = useState(false);

    function handleSubNav() {
        setSubnav(prevData => !prevData)
    };

    function checkActive({ path }) {
        return location.pathname.includes(path)
    }

    useEffect(() => {
        function onLocationChange() {
            menu.submenu.map((item) => (
                location.pathname === item.path && setSubnav(true)
            ))
        }
        if (menu.path === '#') {
            onLocationChange()
        }
    }, [location, menu])

    return (
        <li className='my-1.5 animate-[0.4s_ease-in-out_0.1s_intro-menu] animate-fill-mode-forwards animate-delay-10 list-none'>
            {menu.submenu.length > 0 ?
                <div
                    onClick={handleSubNav}
                    className={classNames(
                        subnav ? 'bg-monko/10 text-monko' : 'text-slate-600 hover:text-monko hover:bg-monko/5',
                        'group w-full px-4 py-3 rounded-2xl flex justify-start items-center text-xs font-medium hover:cursor-pointer transition-all duration-200'
                    )}
                >
                    <menu.icon
                        className={classNames(
                            subnav ? 'fill-monko' : 'fill-slate-500 group-hover:fill-monko',
                            'h-6 w-6 transition-colors duration-200'
                        )}
                    />
                    <div className='flex justify-between w-full items-center'>
                        <span
                            className={classNames(
                                subnav ? 'text-monko font-bold' : 'text-slate-600 group-hover:text-monko font-semibold',
                                'text-sm ml-3 transition-colors duration-200'
                            )}
                        >
                            <IntlMessage id={menu.title} />
                        </span>
                        <ChevronDownIcon
                            className={classNames(
                                subnav ? 'text-monko rotate-180' : 'text-slate-400 group-hover:text-monko',
                                'h-4 w-4 transform transition duration-200'
                            )}
                        />
                    </div>
                </div>
                :
                <MenuLink
                    menu={menu}
                    active={checkActive({ path: menu.path })}
                    onClick={onClick}
                />
            }
            <Transition.Root as={Fragment} show={subnav}>
                <Transition.Child
                    enter='transition ease-out duration-100'
                    enterFrom='transform opacity-0 -translate-y-2'
                    enterTo='transform opacity-100 translate-y-0'
                    leave='transition ease-in duration-75'
                    leaveFrom='transform opacity-100 translate-y-0'
                    leaveTo='transform opacity-0 -translate-y-2'
                >
                    <ul className='bg-slate-50/50 border border-slate-100/50 rounded-2xl relative mt-1 py-1 px-1.5 block'>
                        {menu.key !== 'configs' && menu.submenu.map((submenu, idx) => (
                            <li className='my-0.5 list-none' key={idx}>
                                <MenuLink
                                    menu={submenu}
                                    active={checkActive({ path: submenu.path })}
                                    onClick={onClick}
                                />
                            </li>
                        ))}
                    </ul>
                </Transition.Child>
            </Transition.Root>
        </li>
    )
}

export default MenuItem